/* 
  Updates the cart content when the cart is updated via Priority/CartWizard plugin
 */
const updateCartContent = () => {
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:refresh", {
      bubbles: true,
    }),
  );
};
window.addEventListener("wesync:cartUpdated", (event) => {
  updateCartContent();
});
window.addEventListener("cartWizard:cartUpdated", (event) => {
  updateCartContent();
});

(() => {
  const ACCOUNT_LABEL = "איזור אישי";
  const ACCOUNT_BUTTON_ATTR = "data-join-club-account-button";

  const getAccountUrl = () =>
    `${window.Shopify?.routes?.root ?? "/"}account`;

  const findJoinClubActions = () => {
    const actions = [
      ...document.querySelectorAll(
        ".ws-join-club__actions:not([data-join-club-actions-enhanced])",
      ),
    ];

    document.querySelectorAll("ws-join-club").forEach((host) => {
      if (!host.shadowRoot) return;
      host.shadowRoot
        .querySelectorAll(
          ".ws-join-club__actions:not([data-join-club-actions-enhanced])",
        )
        .forEach((el) => actions.push(el));
    });

    return actions;
  };

  const initJoinClubAccountButton = () => {
    findJoinClubActions().forEach((actions) => {
      const existingChildren = [...actions.childNodes].filter(
        (node) =>
          node.nodeType !== Node.TEXT_NODE || node.textContent.trim() !== "",
      );
      if (existingChildren.length === 0) return;

      const wrapper = document.createElement("div");
      wrapper.style.display = "flex";
      wrapper.style.justifyContent = "space-between";
      wrapper.style.width = "100%";

      const existingGroup = document.createElement("div");
      existingGroup.style.display = "flex";
      existingGroup.style.gap = "5px";
      existingChildren.forEach((child) => existingGroup.appendChild(child));

      const template = existingGroup.querySelector("button, a");
      const accountButton = document.createElement("button");
      accountButton.type = "button";
      accountButton.textContent = ACCOUNT_LABEL;
      accountButton.setAttribute(ACCOUNT_BUTTON_ATTR, "");
      if (template?.className) {
        accountButton.className = template.className;
      }
      accountButton.addEventListener("click", () => {
        window.location.href = getAccountUrl();
      });

      wrapper.append(accountButton, existingGroup);
      actions.append(wrapper);
      actions.dataset.joinClubActionsEnhanced = "true";
    });
  };

  let observer = null;

  const watchJoinClubAccountButton = () => {
    initJoinClubAccountButton();

    if (observer) return;

    observer = new MutationObserver(initJoinClubAccountButton);
    observer.observe(document.body, { childList: true, subtree: true });
  };

  watchJoinClubAccountButton();

  document.addEventListener("click", (event) => {
    if (!event.target.closest("[data-club-join-trigger]")) return;
    requestAnimationFrame(initJoinClubAccountButton);
    setTimeout(initJoinClubAccountButton, 100);
  });

  document.addEventListener("shopify:section:load", watchJoinClubAccountButton);
})();

(() => {
  const HOST_MARKER = "data-shopify-account-rtl-watching";
  const CUSTOMER_DETAILS_MARKER = "data-cotton-customer-details";
  const MOBILE_MEDIA_QUERY =
    window.themeVariables?.mediaQueries?.["sm-max"] ??
    "screen and (max-width: 699px)";

  const CUSTOMER_DETAIL_LABELS = {
    phone: "טלפון",
    birthdate: "תאריך לידה",
    erp: "מספר כרטיס מועדון",
  };

  const isMobile = () => window.matchMedia(MOBILE_MEDIA_QUERY).matches;

  const getShopifyAccountCustomerDetails = (host) => {
    const details = [
      { key: "phone", value: host.dataset.customerPhone },
      { key: "birthdate", value: host.dataset.customerBirthdate },
      { key: "erp", value: host.dataset.customerErp },
    ].filter((detail) => detail.value);

    return details.length > 0 ? details : null;
  };

  const applyShopifyAccountDialogStyles = (host) => {
    const shadowRoot = host.shadowRoot;
    if (!shadowRoot) return;

    shadowRoot.querySelectorAll("dialog").forEach((dialog) => {
      dialog.style.direction = "rtl";
      dialog.style.right = isMobile() ? "" : "30px";
    });

    shadowRoot.querySelectorAll(".account__menu-region").forEach((menuRegion) => {
      menuRegion.style.paddingTop = "10px";
    });
  };

  const getCustomerDetailsSignature = (customerDetails) =>
    customerDetails.map(({ key, value }) => `${key}:${value}`).join("|");

  const injectShopifyAccountCustomerDetails = (host) => {
    const customerDetails = getShopifyAccountCustomerDetails(host);
    const shadowRoot = host.shadowRoot;
    if (!shadowRoot) return;

    const account = shadowRoot.querySelector(".account");
    if (!account) return;

    const headerRegion = account.querySelector(".account__header-region");
    if (!headerRegion) return;

    let detailsBlock = account.querySelector(`[${CUSTOMER_DETAILS_MARKER}]`);

    if (!customerDetails) {
      detailsBlock?.remove();
      return;
    }

    const signature = getCustomerDetailsSignature(customerDetails);
    if (detailsBlock?.dataset.signature === signature) return;

    if (!detailsBlock) {
      detailsBlock = document.createElement("div");
      detailsBlock.setAttribute(CUSTOMER_DETAILS_MARKER, "");
      headerRegion.insertAdjacentElement("afterend", detailsBlock);

      const style = document.createElement("style");
      style.textContent = `
        [${CUSTOMER_DETAILS_MARKER}] {
          display: flex;
          flex-direction: column;
          gap: 0.35rem;
          padding: 0 1.25rem 1rem;
          font-family: var(--shopify-account-font-body, inherit);
          font-size: 0.875rem;
          color: var(--shopify-account-color-text-subdued, currentColor);
          border-bottom: 1px solid var(--shopify-account-color-border, rgba(0, 0, 0, 0.08));
        }

        [${CUSTOMER_DETAILS_MARKER}] dl {
          display: grid;
          grid-template-columns: max-content 1fr;
          gap: 0.2rem 0.75rem;
          margin: 0;
        }

        [${CUSTOMER_DETAILS_MARKER}] dt {
          margin: 0;
          font-weight: 600;
          color: var(--shopify-account-color-text, inherit);
        }

        [${CUSTOMER_DETAILS_MARKER}] dd {
          margin: 0;
          overflow-wrap: anywhere;
        }
      `;
      detailsBlock.append(style);
    }

    let list = detailsBlock.querySelector("dl");
    if (!list) {
      list = document.createElement("dl");
      detailsBlock.append(list);
    }

    list.replaceChildren(
      ...customerDetails.flatMap(({ key, value }) => {
        const term = document.createElement("dt");
        term.textContent = CUSTOMER_DETAIL_LABELS[key];

        const description = document.createElement("dd");
        description.textContent = value;

        return [term, description];
      }),
    );

    detailsBlock.dataset.signature = signature;
  };

  const applyShopifyAccountEnhancements = (host) => {
    applyShopifyAccountDialogStyles(host);
    injectShopifyAccountCustomerDetails(host);
  };

  const watchShopifyAccountShadow = (host) => {
    if (host.hasAttribute(HOST_MARKER)) return;

    const startWatching = () => {
      const shadowRoot = host.shadowRoot;
      if (!shadowRoot) return false;

      host.setAttribute(HOST_MARKER, "");
      let applying = false;

      const runEnhancements = () => {
        if (applying) return;
        applying = true;
        applyShopifyAccountEnhancements(host);
        applying = false;
      };

      const attachObservers = () => {
        const headerRegion = shadowRoot.querySelector(".account__header-region");
        if (!headerRegion) return false;

        new MutationObserver(runEnhancements).observe(headerRegion, {
          childList: true,
        });

        return true;
      };

      runEnhancements();

      if (!attachObservers()) {
        const waitObserver = new MutationObserver(() => {
          if (attachObservers()) waitObserver.disconnect();
        });
        waitObserver.observe(shadowRoot, { childList: true, subtree: true });
      }

      document.addEventListener("shopify-render", runEnhancements);

      return true;
    };

    if (startWatching()) return;

    const hostObserver = new MutationObserver(() => {
      if (startWatching()) hostObserver.disconnect();
    });

    hostObserver.observe(host, { childList: true });

    let attempts = 0;
    const tryObserve = () => {
      if (startWatching() || ++attempts > 120) {
        hostObserver.disconnect();
        return;
      }
      requestAnimationFrame(tryObserve);
    };

    tryObserve();
  };

  let shopifyAccountObserver = null;
  let resizeListenerAttached = false;

  const initShopifyAccountRtl = () => {
    document.querySelectorAll("shopify-account").forEach(watchShopifyAccountShadow);
  };

  const watchShopifyAccountRtl = () => {
    initShopifyAccountRtl();

    if (!resizeListenerAttached) {
      resizeListenerAttached = true;
      window.addEventListener("resize", () => {
        document
          .querySelectorAll("shopify-account")
          .forEach(applyShopifyAccountEnhancements);
      });
    }

    if (shopifyAccountObserver) return;

    shopifyAccountObserver = new MutationObserver(initShopifyAccountRtl);
    shopifyAccountObserver.observe(document.body, { childList: true, subtree: true });

    const onReady = () => initShopifyAccountRtl();

    customElements.whenDefined("shopify-account").then(onReady);
    if (customElements.get("shopify-account")) onReady();
  };

  watchShopifyAccountRtl();
  document.addEventListener("shopify:section:load", initShopifyAccountRtl);
})();
